module.exports = __webpack_public_path__ + "img/qrpay.684ee1db.png";